import type { Creature, CreatureState } from '@/domain/creature/types';
import type { FoodId } from './foods';
import { deriveTemperament, hasTemperament } from './temperament';

const clamp = (n: number, lo: number, hi: number): number => Math.min(hi, Math.max(lo, n));

export function applyTemperamentFoodEffect(creature: Creature, foodId: FoodId, state: CreatureState): CreatureState {
  const temperament = deriveTemperament(creature.genome);
  if (foodId !== 'snack' || !hasTemperament(temperament, 'glutton')) return state;
  return {
    ...state,
    happiness: clamp(state.happiness + 2, 0, 100),
    weight: clamp(state.weight + 1, 1, 99),
  };
}

export function playHappinessDelta(creature: Creature): number {
  const temperament = deriveTemperament(creature.genome);
  if (hasTemperament(temperament, 'playful')) return 3;
  if (hasTemperament(temperament, 'needy')) return 2;
  return 0;
}

export function cleanHappinessDelta(creature: Creature, hadPoop: boolean): number {
  if (!hadPoop) return 0;
  const temperament = deriveTemperament(creature.genome);
  return hasTemperament(temperament, 'tidy') ? 2 : 0;
}

export function wrongDisciplinePenalty(creature: Creature): number {
  const temperament = deriveTemperament(creature.genome);
  return hasTemperament(temperament, 'stubborn') ? 14 : 10;
}
